export const osnOsnPlusIcon = {
  // eslint-disable-next-line max-len
  data: `<svg viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.55582 2.48608C4.92803 2.75287 4.22603 2.80368 3.56479 2.6302V0.317017H2.40468V2.3443C1.60689 2.16241 0.772416 2.20739 0 2.47392L0.380457 3.52605C1.18943 3.2564 1.78305 3.33668 2.40438 3.48839V5.68295H3.56479V3.76826C3.83203 3.81832 4.10345 3.84415 4.37556 3.84542C4.93514 3.84144 5.4883 3.72874 6.00277 3.51389L5.55582 2.48608Z" fill="currentColor"/></svg>`,
  name: 'osn-plus',
};
